import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { UniqueMechanism } from './components/UniqueMechanism';
import { PandoraBox } from './components/PandoraBox';
import { Features } from './components/Features';
import { Audience } from './components/Audience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { OfferCTA } from './components/OfferCTA';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-dark text-white font-sans selection:bg-primary selection:text-dark" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <FailedSolutions data-id="element-5" />
        <UniqueMechanism data-id="element-6" />
        <PandoraBox data-id="element-7" />
        <Features data-id="element-8" />
        <Audience data-id="element-9" />
        <HowItWorks data-id="element-10" />
        <Proof data-id="element-11" />
        <FAQ data-id="element-12" />
        <OfferCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}